// const baseURL = "http://localhost:8000/api/v1"
const baseURL = "https://test.api.rentbeta.iolabz.ug/api/v1"
const imageURL = "https://api.rentbeta.iolabz.ug"
const tuyaUrl = "https://openapi.tuyaeu.com"

// const imageURL = "https://api.rentbeta.iolabz.ug"
// const baseURL = "https://api.rentbeta.iolabz.ug/api/v1"
export {baseURL, imageURL, tuyaUrl}
